import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import * as R from 'ramda'
import { mapProps } from 'recompose'

import Schedule from 'components/form/notebookSchedule/index'
import { createNamedReducer } from 'helpers/ReducerUtil'
import { createNamedAction } from 'helpers/ActionUtil'
import { scheduleValueReducer, createUiReducer } from './reducer'
import injectReducers from 'helpers/injectReducers'
import {
  getValuesSelector,
  default as getSelectors
} from './selectors'
import {
  changeInput,
  changeDate,
  inputUiChange,
  initUi,
} from './actions'
import {
  getPath,
  getUiPath,
  combinePath
} from 'containers/Form/util'
import withValidation from 'containers/Form/Util/Validation/date'
import { isDate } from 'containers/Form/Util/Validation/predicates'

const withReducer = (path, id) => {
  const valuePath = getPath(path, id)
  const uiPath = getUiPath(id)

  const valueReducer = createNamedReducer(valuePath, scheduleValueReducer)
  const uiReducer = createUiReducer(uiPath)

  return injectReducers({
    [valuePath]: valueReducer,
    [uiPath]: uiReducer,
  })
}

const withConnect = (path, id) => {
  const combinedPath = combinePath(path, id)
  const valuePath = getPath(path, id)
  const uiPath = getUiPath(id)

  const inputChangeAction = createNamedAction(valuePath, changeInput)
  const dateChangeAction = createNamedAction(valuePath, changeDate)
  const initUiAction = createNamedAction(uiPath, initUi)
  const inputUiChangeAction = createNamedAction(uiPath, inputUiChange)

  const {
    valuesSelector,
    formatDatesSelector,
    dateIntsSelector,
    inputTextSelector,
  } = getSelectors(combinedPath, uiPath)

  const mapStateToProps = (state) => {
    return {
      values: valuesSelector(state),
      dateInts: dateIntsSelector(state),
      formatDates: formatDatesSelector(state),
      inputText: inputTextSelector(state),
    }
  }

  const mapDispatchToProps = (dispatch) => {
    return {
      onInputChange: (label, text) => {
        dispatch(inputChangeAction(label, text))
      },
      onDateChange: (label, date) => {
        dispatch(dateChangeAction(label, date))
      },
      initUi: (value) => {
        dispatch(initUiAction(value))
      },
      onInputUiChange: (label, text) => {
        dispatch(inputUiChangeAction(label, text))
      }
    }
  }

  return connect(mapStateToProps, mapDispatchToProps)
}

export { default as Schedule } from 'components/form/notebookSchedule/index'
export {
  withConnect,
  withReducer
}

export default R.curry((path, id) => R.compose(
  mapProps((props) => ({ ...props, rules: isDate })),
  withReducer(path, id),
  withConnect(path, id),
  withValidation(path, id, getValuesSelector(id)),
)(Schedule))
